import palette from '../palette';

export default {
  styleOverrides: {
    root: {
      // marginTop: 0,
      // height: 40,
    },
    // standard: {
    //   height: 40,
    // },
    // outlined: {
    //   height: 'auto',
    // },
    select: {
      '&:focus': {
        backgroundColor: 'transparent',
      },
    },
    icon: {
      color: palette.primary.main,
      top: '8px',
    },
  },
};
